/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, ButtonGroup, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { PopperButton } from 'components/popper'
import { useMemo, useState } from 'react'

import { AgendamentoReservaForm } from './AgendamentoReservaForm'

export const AgendamentoCadastroView = () => {
  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme), [theme])

  const [isAgendamentoReserva, setIsAgendamentoReserva] = useState(false)

  const renderPopper = ({ close }) => {
    return (
      <Box style={styles.box}>
        <VFlow>
          <ButtonGroup>
            <Button
              kind={!isAgendamentoReserva ? 'primary' : 'normal'}
              size='small'
              onClick={() => setIsAgendamentoReserva(false)}
            >
              Consulta
            </Button>
            <Button
              kind={isAgendamentoReserva ? 'primary' : 'normal'}
              size='small'
              onClick={() => setIsAgendamentoReserva(true)}
            >
              Reserva
            </Button>
          </ButtonGroup>
          {isAgendamentoReserva && <AgendamentoReservaForm onClose={close} />}
        </VFlow>
      </Box>
    )
  }

  return (
    <PopperButton size='small' placement='bottom-end' renderPopper={renderPopper}>
      <Icon icon='plus' style={{ marginRight: '0.25rem' }} />
      <Text color='inherit'>Adicionar agendamento</Text>
    </PopperButton>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    border: 0.063rem solid ${theme.pallete.gray.c80};
    border-radius: ${theme.radius.modal}px;
    box-sizing: border-box;
    box-shadow: ${theme.shadows.outer[10]};
    width: 50rem;
  `,
})
